import React from 'react'
import Link from 'next/link'
import { MenuItemType } from '@next-nx/utils/types'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import styles from './CircleBoxSmall.module.sass'
import { getAnchorRel } from '@next-nx/utils'

interface Props {
  item: MenuItemType
  handleTracking?: () => void
  className?: string
  setOpen?: (v: boolean) => void
}

const CircleBoxSmall = (props: Props) => {
  const {
    item = undefined,
    handleTracking = () => undefined,
    className = '',
    setOpen = undefined,
  } = props

  return item && item.description && !setOpen ? (
    <Link href={item.url || '#'}>
      <a
        className={`${styles.root} ${className}`}
        rel={getAnchorRel(item.url || '')}
        onClick={handleTracking}
      >
        <div className={styles.content}>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          <span className={styles.icon}>
            <ArrowRight />
          </span>
        </div>
      </a>
    </Link>
  ) : item && item.description && setOpen ? (
    <div
      onClick={() => {
        setOpen(true)
      }}
      style={{ cursor: 'pointer' }}
    >
      <a
        className={`${styles.root} ${className}`}
        rel={getAnchorRel(item.url || '')}
        onClick={handleTracking}
      >
        <div className={styles.content}>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          <span className={styles.icon}>
            <ArrowRight />
          </span>
        </div>
      </a>
    </div>
  ) : (
    <></>
  )
}

export default CircleBoxSmall
